export enum MeetingStatus {
  Unconfirmed = 'unconfirmed',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
}
